/*
	支払方法管理画面
	クレジットカード新規作成　入力画面
*/

import React, { memo } from 'react';
import { PayPalHostedFieldsProvider, PayPalHostedField, PAYPAL_HOSTED_FIELDS_TYPES } from '@paypal/react-paypal-js';
import classes from './new-card-registration-form.module.scss';
import { AgreeSendingCardInfo } from 'components/molecules/agree-sending-card-info/AgreeSendingCardInfo';
import { monthSelectList } from 'consts/CardConst';
import { NewCardInputForm } from 'components/molecules/new-card-input-form/NewCardInputForm';
import { Hr } from 'components/atoms/Hr';
import { PrimaryButton } from 'components/atoms/primary-button/PrimaryButton';

type Props = {
	isSaveCard: boolean;
	isAgreeSendCardInfo: boolean;
	activeButtonMessage?: string;
	passiveButtonVisibleFlg?: boolean;
	buttonBoxVisibleFlg?: boolean;
	transitionPage: number;
	backPage?: number;
	isGakkenUser?: boolean;
	setPage: (value: React.SetStateAction<number>) => void;
	createOrder: () => Promise<string>;
	handleChangeCheckValue: (event: React.ChangeEvent<HTMLInputElement>) => void;
	handleChangeAgreeCheckValue: (event: React.ChangeEvent<HTMLInputElement>) => void;
	SubmitPayment: (props: any) => JSX.Element;
	selectedPeriodicPaymentFlg?: boolean;
};
export const NewCardRegistrationForm = memo((props: Props) => {
	const {
		isSaveCard,
		isAgreeSendCardInfo,
		activeButtonMessage,
		passiveButtonVisibleFlg = true,
		buttonBoxVisibleFlg = true,
		transitionPage,
		backPage,
		isGakkenUser = true,
		setPage,
		createOrder,
		handleChangeCheckValue,
		handleChangeAgreeCheckValue,
		SubmitPayment,
		selectedPeriodicPaymentFlg = false,
	} = props;
	return (
		<PayPalHostedFieldsProvider
			// 次へ押下時にsubmitの前に発火
			createOrder={createOrder}
			// 資格情報が無い場合に発火
			notEligibleError={<div>Your account is not eligible</div>}
		>
			<PayPalHostedField
				hostedFieldType={PAYPAL_HOSTED_FIELDS_TYPES.NUMBER}
				options={{ selector: '#card-number', placeholder: '********' }}
			/>
			<PayPalHostedField
				hostedFieldType={PAYPAL_HOSTED_FIELDS_TYPES.EXPIRATION_MONTH}
				options={{
					selector: '#expiration-month',
					placeholder: 'MM',
					select: monthSelectList,
				}}
			/>
			<PayPalHostedField
				hostedFieldType={PAYPAL_HOSTED_FIELDS_TYPES.EXPIRATION_YEAR}
				options={{
					selector: '#expiration-year',
					placeholder: 'YYYY',
					select: true,
				}}
			/>
			<PayPalHostedField
				hostedFieldType={PAYPAL_HOSTED_FIELDS_TYPES.CVV}
				options={{ selector: '#cvv', placeholder: '123' }}
			/>
			<div className={classes.paymentCreditCardInput}>
				<NewCardInputForm
					isSaveCard={isSaveCard}
					handleChangeCheckValue={handleChangeCheckValue}
					isGakkenUser={isGakkenUser}
					selectedPeriodicPaymentFlg={selectedPeriodicPaymentFlg}
				/>
				<AgreeSendingCardInfo
					isAgreeSendCardInfo={isAgreeSendCardInfo}
					handleChangeAgreeCheckValue={handleChangeAgreeCheckValue}
				/>
			</div>
			{buttonBoxVisibleFlg && (
				<>
					<Hr />
					<div className="btn-box">
						{passiveButtonVisibleFlg ? (
							<div className={`btn wh`}>
								<PrimaryButton message="別のカードで支払う" onClickEvent={() => setPage(transitionPage)} />
							</div>
						) : (
							<div className={`btn wh`}>
								<PrimaryButton message="戻る" onClickEvent={() => setPage(backPage)} />
							</div>
						)}
						<SubmitPayment label={activeButtonMessage ?? undefined} />
					</div>
				</>
			)}
		</PayPalHostedFieldsProvider>
	);
});
